import * as React from "react";
import { DefaultButton } from "@fluentui/react";
import { LanguageContext } from "../utilities/LocalizationModule";
import MessageScreen from "../screens/MessageScreen";
import { retryPortalSignIn } from "../utilities/helpers/portalSignIn";

/**
 * MsalAuthenticationTemplate's error screen: Microsoft's sign-in failed. Try again goes through
 * retryPortalSignIn, as on Home's identical screen (review 2026-10-19): a bare reload kept the
 * "redirected once" flag and could show this screen again.
 */
const AuthError: React.FC = () => {
    const languageStrings = React.useContext(LanguageContext);
    const actionButton = <DefaultButton
        onClick={() => {
            retryPortalSignIn();
        }}>
        {languageStrings.TryAgain}
    </DefaultButton>
    return <MessageScreen text={languageStrings.AuthFailed} actionButton={actionButton} />;
};

export default AuthError;
